import {
    takeLatest, all, put, call,
} from 'redux-saga/effects';
import Cookies from 'universal-cookie';
import _ from 'lodash';
import API from '../common/API';
import * as Actions from '../actions/Home';
import { LoginReceived } from '../actions/Auth';

const persistenceAuth = (response) => {
    const cookies = new Cookies();
    if (response) {
        // set token to cookies
        cookies.set('oest', response.token, {
            path: '/',
        });
        // set role to cookies
        cookies.set('osesr', response.role, {
            path: '/',
        });
        // set viewer type to cookies
        cookies.set('osesvt', response.viewer_type, {
            path: '/',
        });
        // set viewer live stream to cookies
        cookies.set('osesvlt', response.viewer_live_stream, {
            path: '/',
        });
        // set organizer type to cookies
        cookies.set('osesot', response.organizer_type, {
            path: '/',
        });
        // set CompanyId to cookies
        cookies.set('osescid', response.company_id, {
            path: '/',
        });
        // set eventName to cookies
        cookies.set('osesen', response.event, {
            path: '/',
        });

        // set has live stream to cookies
        cookies.set('oseslt', response.has_live_stream, {
            path: '/',
        });

        // cookies.set('oesFt', !_.isUndefined(response.freeType) ? response.freeType : '', {
        //     path: '/',
        // });
        cookies.set('oesFs', !_.isUndefined(response.freeSeminar) ? response.freeSeminar : '', {
            path: '/',
        });
        cookies.set('oesFls', !_.isUndefined(response.freeLiveStream) ? response.freeLiveStream : '', {
            path: '/',
        });
        cookies.set('oesFe', !_.isUndefined(response.freeExhibition) ? response.freeExhibition : '', {
            path: '/',
        });
        cookies.set('oesWa', !_.isUndefined(response.isWeakAuth) ? response.isWeakAuth : '', {
            path: '/',
        });
    }
};

function* getAdvertisement(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/event/${action.payload.event_name}/display-ads/?language=${action.payload?.language}`
        : `/api/v1/event/${action.payload.event_name}/display-ads/`;
    try {
        const response = yield call(
            API.get,
            {
                endpoint,
            },
        );
        yield put(Actions.getAdvertisementReceived(response));
    } catch (error) {
        yield put(Actions.getAdvertisementReceivedFailured(yield error));
    }
}

function* loginOuterServer(action) {
    try {
        const response = yield call(
            API.post,
            {
                endpoint: '/api/v1/login_by_token/',
                body: '',
                token: action.payload,
            },
        );
        persistenceAuth(response);
        yield put(LoginReceived({
            ...response,
            freeSeminar: '',
            freeLiveStream: '',
            freeExhibition: '',
            isWeakAuth: '',
            hasLiveStream: 'undefined',
        }));
        yield put(Actions.loginOuterServerReceived(response));
    } catch (error) {
        yield put(Actions.loginOuterServerReceivedFailure(yield error));
    }
}

export default function* home() {
    yield all([
        takeLatest('GET_ADVERTISEMENT_DATA_REQUESTED', getAdvertisement),
        takeLatest('LOGIN_OUTER_SERVER_REQUEST', loginOuterServer),
    ]);
}
